import Box from '@mui/material/Box';
import { useTheme } from '../../../theme';
import { Caption } from '../../../typography';
import type { ReactNode, JSX } from 'react';

type PlainProps = {
  text: ReactNode;
  className?: string;
  children?: ReactNode;
};

export const TooltipPlain = ({
  text,
  className,
  children,
}: PlainProps): JSX.Element => {
  const theme = useTheme('dark');
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        maxWidth: 200,
        minHeight: 24,
        alignItems: 'center',
      }}
    >
      <Caption
        color={theme.text.generic.secondary}
        css={{
          padding: theme.spacing(0, 1),
          wordBreak: 'break-word',
        }}
      >
        {text}
      </Caption>
      {children}
    </Box>
  );
};
